$(document).ready(function() {
    if ($('body').data('router-name') !== 'product-show') {
        return;
    }

    // zobrazeni formuláře na základě zvolených dat
    $(function () {
        $ajaxBoxes = $('[data-box-ajax]');
        $ajaxBoxes.each(function(i, el) {
            var $boxContent = $(el);
            var type = $boxContent.data('box-ajax');
            $.ajax({
                'url': window.location.href,
                'data': {
                    '_action': 'ajax',
                    'type': type,
                },
                success: function(response) {
                    if (response.status === 'success') {
                        $boxContent.html(response.html);
                    }
                }
            });
        });
    });

});
